(() => {
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => Array.from(el.querySelectorAll(s));
  const routes = (window.cohort && window.cohort.routes) || { cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change', root: '/' };

  /* header height -> content offset */
  const header = $('[data-header]');
  const setHeader = () => { if (header) document.documentElement.style.setProperty('--header-h', header.offsetHeight + 'px'); };
  setHeader();
  window.addEventListener('resize', setHeader);
  if (header) $$('img', header).forEach(i => i.complete ? setHeader() : i.addEventListener('load', setHeader));
  if (document.fonts) document.fonts.ready.then(setHeader);

  /* money */
  const money = (cents) => {
    const v = cents / 100;
    const s = Number.isInteger(v) ? String(v) : v.toFixed(2);
    return '$' + s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };
  const decode = (s) => { const t = document.createElement('textarea'); t.innerHTML = String(s); return t.value; };
  const esc = (s) => decode(s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  /* ---------------- cart drawer ---------------- */
  const drawer = $('[data-cart-drawer]');
  const itemsEl = $('[data-cart-items]');
  const checkoutBtn = $('[data-cart-checkout]');
  let lastFocus = null;

  const updateCount = (count) => {
    $$('[data-cart-count-label]').forEach(el => { el.textContent = count > 0 ? ` (${count})` : ''; });
  };

  const chevron = (d) => `<svg viewBox="0 0 12 8" aria-hidden="true"><path d="${d}" fill="none" stroke="currentColor" stroke-width="1.3"/></svg>`;

  const render = (cart) => {
    updateCount(cart.item_count);
    if (!itemsEl) return;
    if (!cart.items.length) {
      itemsEl.innerHTML = '<p class="cart-drawer__empty">Your cart is empty.</p>';
      if (checkoutBtn) checkoutBtn.disabled = true;
      return;
    }
    if (checkoutBtn) checkoutBtn.disabled = false;
    itemsEl.innerHTML = cart.items.map((it, i) => `
      <div class="cart-item" data-line="${i + 1}">
        <div class="cart-item__top">
          <span>${esc(it.product_title)}${it.product_has_only_default_variant ? '' : ` <span class="cart-item__variant">– ${esc(it.variant_title)}</span>`}</span>
          <button type="button" class="cart-item__remove" data-qty="0" aria-label="Remove ${esc(it.product_title)}">×</button>
        </div>
        <div class="cart-item__bottom">
          <span class="cart-item__qty">${it.quantity}
            <span class="cart-item__step">
              <button type="button" data-qty="${it.quantity + 1}" aria-label="Increase quantity">${chevron('M1.5 6.5L6 2l4.5 4.5')}</button>
              <button type="button" data-qty="${it.quantity - 1}" aria-label="Decrease quantity">${chevron('M1.5 1.5L6 6l4.5-4.5')}</button>
            </span>
          </span>
          <span>${money(it.final_line_price)}</span>
        </div>
      </div>`).join('') +
      `<div class="cart-drawer__subtotal">Subtotal: <span>${money(cart.total_price)}</span></div>`;
  };

  const fetchCart = () => fetch(routes.cart + '.js', { headers: { Accept: 'application/json' } }).then(r => r.json());
  const refresh = () => fetchCart().then(render);

  const open = () => {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    const panel = $('.cart-drawer__panel', drawer);
    if (panel) setTimeout(() => panel.focus(), 50);
  };
  const close = () => {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
    if (lastFocus) lastFocus.focus();
  };

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-cart-open]');
    if (opener && drawer) { e.preventDefault(); refresh().then(open); return; }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); close(); return; }
    const qtyBtn = e.target.closest('[data-qty]');
    if (qtyBtn && itemsEl && itemsEl.contains(qtyBtn)) {
      const line = Number(qtyBtn.closest('[data-line]').dataset.line);
      fetch(routes.cartChange + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity: Math.max(0, Number(qtyBtn.dataset.qty)) })
      }).then(r => r.json()).then(render);
    }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { close(); closeLightbox(); } });

  const addToCart = (id, qty = 1) => fetch(routes.cartAdd + '.js', {
    method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }] })
  }).then(async r => { const j = await r.json(); if (!r.ok) throw j; return j; });

  /* quick-add tiles (e.g. digital release) */
  $$('[data-quick-add]').forEach(el => el.addEventListener('click', (e) => {
    e.preventDefault();
    addToCart(el.dataset.quickAdd).then(refresh).then(open).catch(err => alert((err && err.description) || 'Could not add to cart'));
  }));

  /* product form */
  $$('[data-product-form]').forEach(form => {
    const btn = $('.shop-product__button', form);
    const sel = $('[data-variant-select]', form);
    const sync = () => {
      if (!sel || !btn) return;
      const opt = sel.options[sel.selectedIndex];
      const ok = opt && opt.dataset.available === 'true';
      btn.disabled = !ok;
      btn.textContent = ok ? btn.dataset.label : btn.dataset.soldout;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', sel.value);
      window.history.replaceState({}, '', url);
    };
    if (sel) sel.addEventListener('change', sync);
    form.addEventListener('submit', (e) => {
      if (!drawer) return;
      e.preventDefault();
      const id = (sel && sel.value) || form.querySelector('[name="id"]').value;
      btn.classList.add('is-loading');
      addToCart(id).then(refresh).then(open)
        .catch(err => alert((err && err.description) || 'Could not add to cart'))
        .finally(() => btn.classList.remove('is-loading'));
    });
  });

  /* ---------------- slideshow ----------------
     Hard cut between slides. data-autoplay="<ms>" on [data-slideshow] advances automatically;
     any manual change (click, swipe) restarts the countdown. Paused while the tab is hidden. */
  $$('[data-slideshow]').forEach(show => {
    const slides = $$('[data-slide]', show);
    if (slides.length < 2) return;
    const delay = Number(show.dataset.autoplay) || 0;
    let i = 0;
    let timer = null;

    const go = (n) => {
      slides[i].classList.remove('is-active');
      $$('video', slides[i]).forEach(v => v.pause());
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active');
      $$('video', slides[i]).forEach(v => v.play && v.play().catch(() => {}));
    };
    const restart = () => {
      clearInterval(timer);
      if (delay) timer = setInterval(() => { if (!document.hidden) go(i + 1); }, delay);
    };
    const step = (n) => { go(n); restart(); };

    $$('[data-slide-prev]', show).forEach(b => b.addEventListener('click', () => step(i - 1)));
    $$('[data-slide-next]', show).forEach(b => b.addEventListener('click', () => step(i + 1)));

    let x0 = null;
    show.addEventListener('touchstart', e => { x0 = e.touches[0].clientX; }, { passive: true });
    show.addEventListener('touchend', e => {
      if (x0 === null) return;
      const dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) step(i + (dx < 0 ? 1 : -1));
    });

    restart();
  });

  /* ---------------- lightbox (zoomable images) ---------------- */
  const lb = $('[data-lightbox]');
  const lbImg = $('[data-lightbox-img]');
  let group = [], gi = 0;
  const showLb = () => { lbImg.src = group[gi]; lb.hidden = false; document.body.classList.add('no-scroll'); };
  function closeLightbox() { if (lb && !lb.hidden) { lb.hidden = true; lbImg.removeAttribute('src'); document.body.classList.remove('no-scroll'); } }
  document.addEventListener('click', (e) => {
    const z = e.target.closest('.zoomable');
    if (!z || !lb || e.target.closest('a')) return;
    const src = (z.matches('[data-zoom]') ? z : $('[data-zoom]', z));
    if (!src) return;
    const scope = z.closest('[data-zoom-group]') || document;
    group = $$('.zoomable', scope).map(el => (el.matches('[data-zoom]') ? el : $('[data-zoom]', el))).filter(Boolean).map(el => el.dataset.zoom);
    gi = Math.max(0, group.indexOf(src.dataset.zoom));
    showLb();
  });
  if (lb) lb.addEventListener('click', closeLightbox);
  document.addEventListener('keydown', (e) => {
    if (!lb || lb.hidden || group.length < 2) return;
    if (e.key === 'ArrowRight') { gi = (gi + 1) % group.length; showLb(); }
    if (e.key === 'ArrowLeft') { gi = (gi - 1 + group.length) % group.length; showLb(); }
  });

  refresh().catch(() => {});
})();
